module.exports = __webpack_public_path__ + "static/logo-experiencias-meiquer-70a1e6ef334ddb2f5ffe8c78eae1f129.svg";